<template>
  <div>
    <NavBar />
    <CalendarView />
  </div>
</template>
  
<script>
import NavBar from "../components/NavBar.vue";
import CalendarView from "../components/CalendarView.vue";

export default {
  components: {
    NavBar,
    CalendarView,
  },
};
</script>